import { useState, useEffect, useCallback } from 'react';
// import CustomerReportsService from '@/services/CustomerReportsService';
import ReportsService from '@/services/reportsService';

const PERIOD_MAP = {
  today: 'today',
  yesterday: 'yesterday',
  thisWeek: 'this_week',
  thisMonth: 'this_month',
  lastMonth: 'last_month',
};

const formatDate = (d) =>
  d instanceof Date ? d.toISOString().split('T')[0] : d;

export default function useSales(initialFilters = {}) {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    period: 'today',
    startDate: undefined,
    endDate: undefined,
    offset: 0,
    limit: 25,
    sortColumn: 'sale_date',
    sortDirection: 'DESC',
  });

  useEffect(() => {
    setFilters(prev => ({ ...prev, ...initialFilters }));
  }, [initialFilters]);

  const fetchSales = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        offset: filters.offset,
        limit: filters.limit,
        sortColumn: filters.sortColumn,
        sortDirection: filters.sortDirection,
      };

      if (filters.branchId) params.branchId = filters.branchId;
      if (filters.ncFilter) params.ncFilter = filters.ncFilter;

      if (filters.startDate && filters.endDate) {
        params.startDate = formatDate(filters.startDate);
        params.endDate = formatDate(filters.endDate);
      } else {
        params.period = PERIOD_MAP[filters.period] ?? filters.period;
      }

     const res = await ReportsService.getDailySales(params);
    const data = res?.data ?? res;
console.log('API DATA:', data);

const rows =
  data?.table?.content?.map((row, index) => ({
    id: `${row.saleDate}-${index}`,
    date: row.saleDate,
    orders: row.totalOrders,
    grossSales: row.grossSales,
    discounts: row.discountAmount,
    netSales: row.netSales,
    tax: row.taxAmount,
    cash: row.cashAmount,
    upi: row.upiAmount,
    card: row.cardAmount,
    avgOrderValue: row.avgOrder,
    branchId: row.branchId,
    ncOrders: row.ncOrders ?? row.nc_orders ?? 0,
    ncAmount: row.ncAmount ?? row.nc_amount ?? 0,
  })) ?? [];




      setData(rows);
      setSummary(res?.summary ?? null);
      setBranchSummary(res?.branchSummary ?? []);
      setTotalItems(res?.table?.totalElements ?? 0);

    } catch (err) {
      console.error(' useSales ERROR:', err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchSales();
  }, [fetchSales]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    setFilters,
    refreshSales: fetchSales,
  };
}
